export const COLUMNS_HEADERS = [
  {id: 'name', key: 'name', label: 'Name'},
  {id: 'location', key: 'location', label: 'Location'},
];

export const RECORDS_PER_PAGE = 20;
